// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useFlagsUnreachableContext } from '../contexts/LaunchDarklyContext';

/**
 * True when LaunchDarkly was given up on for this identity (its identify retries are spent),
 * so readiness will not arrive. A readiness gate can then say so instead of staying blank
 * (AB#35012).
 */
export function useFlagsUnreachable(): boolean {
  return useFlagsUnreachableContext();
}
